var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 237.994H513V341.994H0V237.994Z",
    fill: "#F4D900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V103.994H0V-0.00585938Z",
    fill: "#006D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 118.994H513V222.994H0V118.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 170.667L0 341.329V-0.0078125L256 170.667Z",
    fill: "#CB0F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.477 109.793L98.584 156.291H147.478L107.924 185.03L123.031 231.529L83.477 202.791L43.922 231.529L59.032 185.03L19.478 156.291H68.37L83.477 109.793Z",
    fill: "#F4D900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMz);
export default __webpack_public_path__ + "static/media/MZ.025857b8368b3c1010c5a8825ea42b61.svg";
export { ForwardRef as ReactComponent };